import Vue from 'vue'

// Vuetify
import vuetifyConfig from './vuetify'
import Vuetify, {} from 'vuetify/lib'
Vue.use(Vuetify, vuetifyConfig)

// Snotify
import snotify,{ snotifyOptions, snotifyAction } from './snotify'
Vue.use(snotify, snotifyOptions)
Vue.prototype.$snotify.error = snotifyAction('error')
Vue.prototype.$snotify.success = snotifyAction('success')

//Portal
import PortalVue from 'portal-vue'
Vue.use(PortalVue)

// ToggleButton
import ToggleButton from "vue-js-toggle-button";
Vue.use(ToggleButton);

// Vee-Validate
import VeeValidate from 'vee-validate'
Vue.use(VeeValidate, { fieldsBagName : 'vee-fields' })

// Context & ACL
import context from './context'
Vue.use(context)

import VueTour from 'vue-tour'
require('vue-tour/dist/vue-tour.css')
Vue.use(VueTour)

import { ObserveVisibility } from 'vue-observe-visibility'
Vue.directive('observe-visibility', ObserveVisibility)

import socketIO from './socket-io'
Vue.use(socketIO)
